import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-priviliges-modal',
  templateUrl: './priviliges-modal.component.html',
  styleUrls: ['./priviliges-modal.component.scss'],
})
export class PriviligesModalComponent implements OnInit {
  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }
}
